import { createContext, useContext, useState, useCallback, type ReactNode } from 'react';

export interface BreadcrumbItem {
	label: string;
	path?: string;
}

interface PageMetaValue {
	title: string;
	breadcrumbs: BreadcrumbItem[];
	setPageMeta: (title: string, breadcrumbs: BreadcrumbItem[]) => void;
}

const PageMetaContext = createContext<PageMetaValue | null>(null);

export function PageMetaProvider({ children }: { children: ReactNode }) {
	const [title, setTitle] = useState('Dashboard');
	const [breadcrumbs, setBreadcrumbs] = useState<BreadcrumbItem[]>([]);

	const setPageMeta = useCallback((t: string, bc: BreadcrumbItem[]) => {
		setTitle(t);
		setBreadcrumbs(bc);
	}, []);

	return (
		<PageMetaContext.Provider value={{ title, breadcrumbs, setPageMeta }}>
			{children}
		</PageMetaContext.Provider>
	);
}

export function usePageMeta() {
	const ctx = useContext(PageMetaContext);
	if (!ctx) throw new Error('usePageMeta must be used within PageMetaProvider');
	return ctx;
}
